import React, {useEffect, useState} from "react";
import HeaderHs2 from "../../../commons/components/Header/headerHs2";
import MainLayout from "../../../commons/layout/MainLayout/index";
import ROUTERS from "../../../commons/constans/router";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import API, {ROUTES} from "../../../commons/api/api";
import {updateNotificationSettingSuccess} from "../../Account/redux/actions";



const NotificationSetting = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userInfo } = useSelector((state) => state.authReducers);

    const DISABLE = 'disable';
    const ENABLE = 'enable';

    const [pushState,setPushState] = useState(DISABLE);
    const [marketingMailState,seMarketingMailState] = useState(DISABLE);

    useEffect(() => {
        if(userInfo && userInfo.setting){
            setPushState(userInfo.setting.push_state);;
            seMarketingMailState(userInfo.setting.marketing_mail_state);
        }
    },[]);

    const handleNotificationSetting = (event) => {
        const target = event.target;
        const  value = target.type === 'checkbox' ? target.checked ? ENABLE : DISABLE : target.value;
        const name = target.name;

        let param = {
            push_state : pushState,
            marketing_mail_state : marketingMailState,
            [name] : value
        }
        API.post(ROUTES.API_NOTIFICATION_SETTING,param).then(res => {
            dispatch(updateNotificationSettingSuccess(param));
            switch (name) {
                case 'push_state' :
                    setPushState(value)
                    break;

                case 'marketing_mail_state' :
                    seMarketingMailState(value)
                    break;
            }
            // API.get(ROUTES.API_UPDATE_AUTH_ME).then(response => {
            //     let user = response.data.data;
            //     dispatch(updateNotificationSettingSuccess(user.setting));
            // })
        })
    }

    return (
        <MainLayout pageID={"setting"} displayBottomNav={false}>
            <HeaderHs2
                title={"알림설정"}
                labelLeft={true}
                labelRight={false}
                handleLabelLeft={()=>{
                    navigate(ROUTERS.HOME, {
                        state: {
                            menuStatus: true
                        }
                    })
                }}
            />

            <div className="wrapper">
                <section className="lists">
                    <div className="lists__item">
                        <div className="lists__item__content">
                            <h3>푸시 알림 수신</h3>
                        </div>
                        <div className="lists__item__action">
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    name={'push_state'}
                                    checked={pushState === ENABLE ? true : false}
                                    onChange={handleNotificationSetting}
                                />
                                    <span className="slider"></span>
                            </label>
                        </div>
                    </div>

                    <div className="lists__item">
                        <div className="lists__item__content">
                            <h3>마케팅 정보 수신</h3>
                        </div>
                        <div className="lists__item__action">
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    name={'marketing_mail_state'}
                                    checked={marketingMailState === ENABLE ? true : false}
                                    onChange={handleNotificationSetting}
                                />
                                    <span className="slider"></span>
                            </label>
                        </div>
                    </div>
                </section>

            </div>

        </MainLayout>
    );
}

export default NotificationSetting;